<template>
  <CstuModal
    id="new-navigation-modal"
    size="md"
    hide-header
    hide-footer
    radius="lg"
    @close="handleCancel"
  >
  <!-- cross icon top right -->
   <div class="absolute -top-4 -right-3" @click="handleCancel">
   <i class="far fa-times text-lg cursor-pointer text-gray-800 hover:text-gray-900"></i>
  </div>
  <div class="flex flex-col items-center justify-center gap-6">
    <h3 class="text-2xl font-bold">Composer & Planner, now in Publisher</h3>
    <p class="text-center text-gray-900 text-[14px]">
      Find Social Composer and Planner under Publisher, alongside other content tools for a cleaner workflow.</p>
     <video src="@src/assets/img/publisher-gif.mp4" class="w-full h-[300px] object-contain rounded-xl"  autoplay muted loop alt="">
     </video>
     <Button full-width @click="handleExplore">
      Explore
     </Button>

  </div>
  </CstuModal>
</template>

<script setup>
import { inject } from 'vue'
import {Button} from '@contentstudio/ui'
import { useRouter } from 'vue-router'
import useHelper from '@/src/modules/common/composables/useHelper'

const root = inject('root')
const { $cstuModal } = root
const { setPreferenceStatus } = useHelper()
const router = useRouter()

const handleExplore = () => {
  // navigate to publisher
  router.push({name: 'publisher'})

  // close modal
  $cstuModal.hide('new-navigation-modal')

  // set preference status
  setPreferenceStatus('new_navigation_modal', false)
}

const handleCancel = () => {
  // close modal
  $cstuModal.hide('new-navigation-modal')

  // set preference status
  setPreferenceStatus('new_navigation_modal', false)
}
</script>
